import { clearButtonStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchClearButton";
import { orderHistorySearchFieldProductErpNumber2Styles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldProductErpNumber2";
import { shipToStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldShipTos";
import { searchFormStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchForm";
import { orderHistorySearchTagsStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchTags";
import { orderHistoryTableStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable";
import { css } from "styled-components";

searchFormStyles.headingText = {
    variant: "h5",
    css: css`
        text-transform: uppercase;
    `,
};

clearButtonStyles.clearButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        float: right;
        margin-bottom: 25px;
        border: 1px solid rgb(1, 11, 19) !important;
    `,
};

orderHistorySearchTagsStyles.appliedFilterTag = {
    css: css`
        button {
            border: none !important;
            background: none !important;
            display: flex;
        }
    `,
};

orderHistorySearchFieldProductErpNumber2Styles.searchDynamicDropdown = {
    cssOverrides: {
        list: css`
            background: #ffffff;
        `,
    },
};

orderHistoryTableStyles.container = {
    css: css`
        overflow: auto;
        padding-bottom: 30px;
    `,
};

orderHistoryTableStyles.orderNumberCells = {
    css: css`
        span {
            color: #006bc0 !important;
        }
    `,
};

orderHistoryTableStyles.customerPOCells = {
    css: css`
        span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
            max-width: 75px;
        }
    `,
};

shipToStyles.dropdown = {
    cssOverrides: {
        list: css`
            background: #ffffff;
        `,
    },
};
